import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.createCalculatorPhyto.success:
        case constants.getCalculatorPhyto.success: {
            return action.payload;
        }

        case constants.createCalculatorPhyto.error:
        case constants.getCalculatorPhyto.error: {
            return initialState;
        }

        case constants.createCalculatorPhyto.try:
        case constants.getCalculatorPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}